import { logger } from 'logging-utils';
import policiesService from '../../services';
import PoliciesStore from '../../store/policies';
import ProfileStore from '../../store/profiles';
import PoliciesProfileUIStateStore from '../../store/policies-profile-ui';
import {
  mergePoliciesChanges,
  prepareProfileInput,
} from '../policies-profile-actions/policy-state-actions';
import { snapshot } from 'valtio';
import {
  enablePoliciesSaveButton,
  setSavePoliciesInProgress,
} from '../policies-selection-ui-actions/policies-selection-ui-actions';

export default async function updateProfileByIdAction(): Promise<void> {
  try {
    const policiesStore = snapshot(PoliciesStore);
    const profileStore = snapshot(ProfileStore);
    if (!profileStore.profileInContext) {
      logger.error('No profile in context');
      return;
    }
    const { profileId, active } = profileStore.profileInContext;
    const dirtyPolicies = policiesStore.dirtyPolicies || {};
    const dirtyPoliciesList = prepareProfileInput(dirtyPolicies);
    mergePoliciesChanges(dirtyPolicies);

    const {
      profile: { version, lastModified, modifiedBy },
    } = await policiesService.updateProfileById.execute({
      profileId,
      policies: dirtyPoliciesList,
      active,
    });


    ProfileStore.activeProfileId = active
      ? profileId
      : profileStore.activeProfileId;

    ProfileStore.profileInContext = {
      ...profileStore.profileInContext,
      modifiedBy,
      lastModified,
      version,
    };

    ProfileStore.profiles = profileStore.profiles.map(profile => {
      return profileId === profile.profileId
        ? { ...profile, ...profileStore.profileInContext }
        : profile;
    });

    ProfileStore.profiles = profileStore.profiles.map(profile => {
      return {
        ...profile,
        active: profileStore.activeProfileId === profile.profileId,
      };
    });

    PoliciesStore.dirtyPolicies = undefined;
  } catch (error) {
    logger.error('update profile by id error', { error });
    PoliciesProfileUIStateStore.generalPoliciesPageError = {
      errorTitle: 'Save Current Profile Settings Failed!',
      errorMsg: 'Failed to load profile content, please try again later.',
    };
  } finally {
    setSavePoliciesInProgress(false);
    enablePoliciesSaveButton(false);
  }
}
